export default __webpack_public_path__ + "static/aws-certified-e80a2755104e04c4509b4656d8f2a1b5.png";